export default "__VITE_ASSET__1L24KZQN__"